interface LoadingGraphicProps {
  label?: string;
}

export const LoadingGraphic = ({ label = 'Loading...' }: LoadingGraphicProps) => (
  <div className="flex flex-col items-center justify-center py-10 text-center">
    <div className="relative w-40 h-40 flex items-center justify-center">
      <img
        src="/images/254albumdefault_sm.png"
        alt=""
        className="w-32 h-32 object-contain opacity-80 bg-white/80 rounded-full p-2 shadow-sm z-10"
        loading="lazy"
        onError={(event) => {
          const target = event.currentTarget;
          target.style.display = 'none';
          const fallback = target.nextElementSibling;
          if (fallback instanceof HTMLElement) {
            fallback.style.display = 'flex';
          }
        }}
      />
      <div
        className="hidden w-32 h-32 rounded-full bg-white/80 text-gray-700 text-lg font-semibold items-center justify-center shadow-sm z-10"
        aria-hidden="true"
      >
        254
      </div>
      <div className="absolute inset-0 flex items-center justify-center z-0">
        <div className="h-20 w-20 rounded-full border-4 border-emerald-200 border-t-emerald-600 animate-spin"></div>
      </div>
    </div>
    <p className="mt-3 text-sm font-medium text-gray-600">{label}</p>
  </div>
);
